import styled from 'styled-components';

export const Container = styled.aside`
  display: flex;
  flex-direction: column;
  width: 16.25rem;
  min-height: 1px;
  height: 600px;
  /* flex: 1 0 auto; */
  background: ${({ theme }) => theme.colors.lighterBackground};
  color: ${({ theme }) => theme.colors.gray[900]};
  box-shadow: 0 0.125rem 0.375rem 0 rgb(161 172 184 / 12%);
  z-index: 1;
  padding-top: 12px;
  /* position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  margin-right: 0 !important;
  margin-left: 0 !important; */
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
`;
